/* eslint-disable no-console */
import React from 'react';
import { render } from 'react-dom';
import { Buffer } from 'buffer';

import affectliSso from 'app/auth/affectliSso';
import { createScript, showScriptError } from 'app/utils/html/script';

import * as serviceWorkerRegistration from './registerServiceWorker';

import { MainApp } from './App';

global.Buffer = Buffer;
window.addEventListener('beforeinstallprompt', event => {
    event.preventDefault();
    window.beforeInstallPromptAffectli = event;
});

async function loadKeycloak() {
    try {
        console.log('[auth] 1. Fetching /config/keycloak.json...');
        const response = await fetch('/config/keycloak.json', {
            method: 'GET',
            headers: { 'content-type': 'application/json' },
        });

        if (response.status !== 200) {
            throw Error(`Failed to load keycloak.json: ${response.status} ${response.statusText}`);
        }

        const keycloak = await response.json();
        console.log('[auth] 2. Config loaded:', keycloak['auth-server-url'], keycloak['realm'], keycloak['resource']);

        if (!keycloak['auth-server-url']) throw Error('No Auth Server Url');

        // Normalize: strip trailing slashes to avoid double-slash in script URL
        const authServerUrl = keycloak['auth-server-url'].replace(/\/+$/, '');
        const keycloakScriptUrl = `${authServerUrl}/js/keycloak.js`;

        // Timeout so the app doesn't stay on "Loading..." indefinitely
        const initTimeoutMs = 15000;
        const timeoutId = setTimeout(() => {
            console.error('[auth] TIMEOUT: Login took longer than 15s');
            showScriptError(
                `Login is taking too long. Check that ${authServerUrl} is reachable and the client "${keycloak['resource']}" is configured in Keycloak.`
            );
        }, initTimeoutMs);

        console.log('[auth] 3. Creating script:', keycloakScriptUrl);
        createScript(keycloakScriptUrl, 'keycloak', () => {
            clearTimeout(timeoutId);
            console.error('[auth] Script failed to load:', keycloakScriptUrl);
            showScriptError(`Failed to load Keycloak script from ${keycloakScriptUrl}`);
        });

        const scriptElem = document.querySelector('#keycloak');
        if (!scriptElem) {
            clearTimeout(timeoutId);
            throw Error('Keycloak script element not found after createScript');
        }
        console.log('[auth] 4. Script element created, src:', scriptElem.src);

        scriptElem.addEventListener('load', function() {
            console.log('[auth] 5. Script loaded, window.Keycloak:', typeof window.Keycloak);

            if (!window.Keycloak) {
                clearTimeout(timeoutId);
                showScriptError('Keycloak script loaded but window.Keycloak is not defined');
                return;
            }

            console.log('[auth] 6. Calling affectliSso.loadConfig()...');
            affectliSso.loadConfig();

            console.log('[auth] 7. Calling affectliSso.initialized()...');
            affectliSso.initialized()
                .then(() => {
                    clearTimeout(timeoutId);
                    console.log('[auth] 8. SSO initialized, rendering app');
                    render(<MainApp />, document.getElementById('root'));
                })
                .catch(err => {
                    clearTimeout(timeoutId);
                    console.error('[auth] SSO initialization failed:', err);
                    showScriptError(`SSO initialization failed: ${err.message}`);
                });
        });
    } catch (error) {
        console.error('[auth] Error:', error);
        showScriptError(error);
    }
}

serviceWorkerRegistration.register();

loadKeycloak();
